import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className"];
import React, { forwardRef } from 'react';
import { HeaderNavigationSelectorRoot, HeaderNavigationSelectorWrapper, SelectedOptions, SelectorDropdownOptionList, SelectorDropdownOptionListContainer, SelectorDropdownOptionListWrapper, SelectorExpansionIndicator, SelectorLabel } from './style';
import { HEADER_NAVIGATION_SELECTOR_CLASS_PREFIX, headerNavigationSelectorRoot } from './constants';
import useHeaderNavigationSelectorClassName from './utils/useHeaderNavigationSelectorClassName';
import { useTheme } from '../../../styling';
import { Pack, PackItem } from '../../Pack';
import { useHeaderNavigationSelector } from './utils/useHeaderNavigationSelector';
export var HeaderNavigationSelector = forwardRef(function HeaderNavigationSelector(_ref, ref) {
  var className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var theme = useTheme().armor;
  var classOverride = useHeaderNavigationSelectorClassName(HEADER_NAVIGATION_SELECTOR_CLASS_PREFIX, className);

  var _useHeaderNavigationS = useHeaderNavigationSelector(restProps, ref),
      rootProps = _useHeaderNavigationS.rootProps,
      selectorProps = _useHeaderNavigationS.selectorProps,
      optionListProps = _useHeaderNavigationS.optionListProps,
      expansionIndicatorProps = _useHeaderNavigationS.expansionIndicatorProps,
      containerRef = _useHeaderNavigationS.containerRef,
      label = _useHeaderNavigationS.label,
      selectedValueToDisplay = _useHeaderNavigationS.selectedValueToDisplay;

  return React.createElement(HeaderNavigationSelectorRoot, Object.assign({}, selectorProps, {
    theme: theme,
    className: classOverride.Root,
    flexGrow: 1
  }), React.createElement(HeaderNavigationSelectorWrapper, Object.assign({
    "data-testid": headerNavigationSelectorRoot
  }, rootProps, {
    theme: theme,
    className: classOverride.Wrapper,
    ref: containerRef
  }), React.createElement(SelectedOptions, {
    className: classOverride.SelectedOptionsContainer
  }, React.createElement(Pack, {
    className: classOverride.SelectedOptions
  }, React.createElement(SelectorLabel, {
    className: classOverride.SelectedOptionsValues
  }, selectedValueToDisplay || label), React.createElement(PackItem, {
    className: classOverride.SelectedOptionsExpansionIndicatorContainer
  }, React.createElement(SelectorExpansionIndicator, Object.assign({}, expansionIndicatorProps, {
    marginLeft: 4,
    theme: theme,
    className: classOverride.SelectedOptionsExpansionIndicator
  }))))), React.createElement(SelectorDropdownOptionListContainer, {
    className: classOverride.OptionListContainer,
    theme: theme
  }, React.createElement(SelectorDropdownOptionListWrapper, {
    className: classOverride.OptionListWrapper,
    theme: theme
  }, React.createElement(SelectorDropdownOptionList, Object.assign({}, optionListProps, {
    className: classOverride.OptionList,
    theme: theme
  }))))));
});
HeaderNavigationSelector.defaultProps = {
  navigationSelectorParams: {
    label: 'Country',
    isMultiselect: false
  },
  separator: true
};